import { CheckCircleIcon, EyeIcon, PencilSquareIcon } from "@heroicons/react/24/outline";

import { Paragraph, Small } from "@fronterahealth/frontera-ui-components";

export const ReviewHeader: React.FC = () => {
  const infoCards = [
    {
      header: "Complete Report Content",
      text: "Fill out all required sections of the reassessment. Review and adjust any AI-generated content to reflect current clinical observations.",
      icon: <EyeIcon className="h-4 w-4" />,
      iconClass: "bg-blue-100 text-blue-600",
    },
    {
      header: "Approve Goal Progress",
      text: "Click into each goal to review them. Approve and include goals you want to communicate to payors, and exclude goals you don’t.",
      icon: <PencilSquareIcon className="h-4 w-4" />,
      iconClass: "bg-yellow-100 text-yellow-600",
    },
    {
      header: "Review & Finalize Report",
      text: "We help run a final audit step for your report to catch any compliance and submission issues before signing. Once reviewed, click “Sign & Complete” to finalize your report.",
      icon: <CheckCircleIcon className="h-4 w-4" />,
      iconClass: "bg-green-100 text-green-600",
    },
  ];

  return (
    <div className="items-start bg-white border-limestone-100 p-6 rounded-3xl">
      <Paragraph displayType="loud" colorType="primary">
        Review & Edit Report
      </Paragraph>
      <Paragraph size="small" displayType="normal" colorType="secondary">
        Review and complete the content below and make any necessary edits to ensure accuracy and completeness before
        finalizing.
      </Paragraph>
      <div className="flex content-stretch gap-2 mt-4">
        {infoCards.map((infoCard, rankOrder) => (
          <div key={rankOrder} className="flex items-start flex-1 bg-limestone-50 text-limestone-700 p-4 rounded-xl">
            <div className={`p-2 rounded-sm mr-2 ${infoCard.iconClass}`}>{infoCard.icon}</div>
            <div className="ml-1">
              <div className="flex gap-2 mb-1">
                <Small displayType="loud" colorType="primary">
                  {rankOrder + 1}.
                </Small>
                <Small displayType="loud" colorType="primary">
                  {infoCard.header}
                </Small>
              </div>
              <Paragraph size="extra-small" displayType="normal" colorType="secondary">
                {infoCard.text}
              </Paragraph>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
